import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Company } from '../../models/company';
import { CompanyService } from '../../services/company.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { VoidExpression } from 'typescript';
import { FileUploaderService } from '../../services/fileuploader.service';
import { DocumentServerService } from '../../services/documentdownload.Service';
import { Button } from 'protractor';
@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerCompany: PageHeader;
  entity: Company = new Company();
  editingEntity: Company = new Company();
  selectedCompany: Company = new Company();
  companys: any;
  companyColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  panCheck: boolean = true;
  gstinCheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  Istextbox: boolean = false;
  Istextbox1: boolean = false;
  IsMandatory: boolean = false;
  maxlength: number = 500;
  Isvalidation: boolean = false;
  savedoc: boolean = false;
  path: string = "";
  fileName: string = "";
  opened: boolean = false;
  details: any;
  addressurl = '';
  addressisButtonVisible: boolean = false;
  CINurl = '';
  CINisButtonVisible: boolean = false;
  PANurl = '';
  PANisButtonVisible: boolean = false;
  TANurl = '';
  TANisButtonVisible: boolean = false;
  MOAurl = '';
  MOAisButtonVisible: boolean = false;
  AOAurl = '';
  AOAisButtonVisible: boolean = false;
  COIurl = '';
  COIisButtonVisible: boolean = false;
  RBIurl = '';
  RBIisButtonVisible: boolean = false;
  OtherEnclosureurl = '';
  OtherEnclosureisButtonVisible: boolean = false;
  download: any;
  PANdownload: any;
  CINdownload: any;
  TANdownload: any;
  AOAdownload: any;
  MOAdownload: any;
  COIdownload: any;
  RBIdownload: any;
  Otherdownload: any;
  isDownloadButtonVisible: boolean = false;
  ARRAY: Array<any> =
    [
      {

      }
    ]
  proofTypes: Array<any> = [
    {
      proofType: "address",
      displayName: "Address",
      refId: "",
      description: "Enter the Address",
      value: "",
      url: this.addressurl,
      button: this.addressisButtonVisible,
      Istextbox: true,
      IsMandatory: true,
      validationMessage: "Address is required"
    },

    {
      proofType: "CIN",
      displayName: "CIN",
      description: "Enter the CIN",
      url: this.CINurl,
      button: this.CINisButtonVisible,
      Istextbox: true,
      IsMandatory: true,
      maxlength: 21,
      validationMessage: "CIN is required"

    },
    {
      proofType: "PAN",
      displayName: "PAN",
      description: "Enter the PAN",
      url: this.PANurl,
      button: this.PANisButtonVisible,
      Istextbox: true,
      IsMandatory: true,
      maxlength: 10,
      validationMessage: "PAN is required"

    },
    {
      proofType: "TAN",
      displayName: "GSTIN",
      description: "Enter the GSTIN",
      url: this.TANurl,
      button: this.TANisButtonVisible,
      Istextbox: true,
      maxlength: 15
    }, {
      proofType: "MOA",
      displayName: "MOA",
      description: "Enter the MOA",
      url: this.MOAurl,
      button: this.MOAisButtonVisible,
      Label: "Choose MOA to upload"
    }, {
      proofType: "AOA",
      displayName: "AOA",
      description: "Enter the AOA",
      url: this.AOAurl,
      button: this.AOAisButtonVisible,
      Istextbox: false,
      Label: "Choose AOA to upload"
    }, {
      proofType: "COI",
      displayName: "COI",
      description: "Enter the COI",
      url: this.COIurl,
      button: this.COIisButtonVisible,
      Label: "Choose COI to upload"
    }, {
      proofType: "RBI",
      displayName: "RBI Licence",
      description: "Enter the RBI Licence",
      url: this.RBIurl,
      button: this.RBIisButtonVisible,
      Istextbox1: true,
      Label: "Choose RBI Licence to upload"
    }, {
      proofType: "OtherEnclosure",
      displayName: "OtherEnclosure",
      description: "Enter OtherEnclosure",
      url: this.OtherEnclosureurl,
      button: this.OtherEnclosureisButtonVisible,
      Istextbox1: true,
      Label: "Choose OtherEnclosure to upload"
    }
  ]

  constructor(
    private _companyService: CompanyService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private fileUploader: FileUploaderService,
    private documentdownloadservice: DocumentServerService,
  ) {
    this.headerCompany = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.companys = [];
    this.getAllCompanys();
  }
  ngAfterViewInit(): void {
    this.companyColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 50 },
      { field: "CompanyName", title: 'Name', filter: true, sortable: true, width: 100 },
      { field: "CompanyAddress", title: 'Address', filter: true, sortable: true, width: 150 },
      { field: "EmailId", title: 'Email', filter: true, sortable: true, width: 100 },
      { field: "Phone", title: 'Phone', filter: true, sortable: true, width: 70 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 50 },
      { field: "", title: '', filter: true, sortable: true, width: 30, template: this.view }
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._companyService.getAllCompany('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Company>) => {
      this.companys = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._companyService.getAllCompany(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((companys: Array<Company>) => {
        this.companys = {
          data: companys,
          total: companys[0] ? companys[0].TotalCount : 0
        }
      });
    }
  }
  getAllCompanys() {
    this._companyService.getAllCompany('', Number(this.defaultPageSize), 1, 0, 0).subscribe((companys: Array<Company>) => {
      this.companys = {
        data: companys,
        total: companys[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._companyService.deleteCompany(this.selectedCompany.Company_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearCompany();
            this.getAllCompanys();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView = true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerCompany = new PageHeader();
    headerCompany.PageCaption = "Company";
    headerCompany.IconClass = "bi bi-building";
    return headerCompany;
  }

  deleteCompany(event: any) {
    if (event.seletedRows[0]) {
      this.selectedCompany.Company_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Company",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addCompany(event: any) {
    this.listView = false;
    this.clearCompany();
    this.formCaption = "Add Company";

  }

  editCompany(event: any): void {
    if (event.seletedRows[0]) {
      this._companyService.viewCompany(event.seletedRows[0]).subscribe((companys: Array<Company>) => {
        let editCompany = companys[0] ? companys[0] : new Company();
        if (editCompany) {
          this.editingEntity = editCompany;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          // this.AOAdownload = ""; this.COIdownload = ""; this.CINdownload = ""; this.MOAdownload = ""; this.Otherdownload = ""; this.PANdownload = "";
          // this.RBIdownload = ""; this.download = ""; this.TANdownload = "";
          this.isDownloadButtonVisible = true;
          this.proofTypes = [
            { proofType: "address", displayName: "Address", value: this.editingEntity.CompanyAddress, IsMandatory: true },
            { proofType: "CIN", displayName: "CIN", value: this.editingEntity.CIN, maxlength: 21, IsMandatory: true },
            { proofType: "PAN", displayName: "PAN", value: this.editingEntity.PAN, maxlength: 10, IsMandatory: true },
            { proofType: "TAN", displayName: "GSTIN", value: this.editingEntity.TAN, maxlength: 15 },
            { proofType: "MOA", displayName: "MOA", value: this.editingEntity.MOA, Label: "Choose MOA to upload" },
            { proofType: "AOA", displayName: "AOA", value: this.editingEntity.AOA, Label: "Choose AOA to upload" },
            { proofType: "COI", displayName: "COI", value: this.editingEntity.COI, Label: "Choose COI to upload" },
            { proofType: "RBI", displayName: "RBI", value: this.editingEntity.RBI_License, Label: "Choose RBI Licence to upload" },
            { proofType: "OtherEnclosure", displayName: "OtherEnclosure", value: this.editingEntity.OtherEnclosure, Label: "Choose OtherEnclosure to upload" }

          ]

          this.formCaption = "Edit Company";
          if (this.entity.FileName != null) {
            this.path = this.configService.getConfigValue('FileWriteLocation');
            this.addressurl = this.path + this.entity.FileName;
            this.addressisButtonVisible = true;
          }
          else {
            this.path = '';
            this.addressurl = '';
            this.addressisButtonVisible = false;
            this.entity.Document = null;
          }
          this.entity.EntityMetaData = [
            { FieldName: 'CompanyName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company Name is required' },
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
          ];
        }
      });
    }
  }

  savedocuments(event: any, type: string) {

    if (type == "address") {
      if (this.entity.Document != null && this.entity.Document != undefined) {
        this.fileUploader.upload(this.entity.Document, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.Address_Ref_Id = result.documentId;
          }

        });
      }
    }
    if (type == "CIN") {
      if (this.entity.cinDocument != null && this.entity.cinDocument != undefined) {
        this.fileUploader.upload(this.entity.cinDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.CIN_Ref_Id = result.documentId;
          }

        });

      }

    }
    if (type == "PAN") {
      if (this.entity.PANDocument != null && this.entity.PANDocument != undefined) {
        this.fileUploader.upload(this.entity.PANDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.PAN_Ref_Id = result.documentId;
          }
        });

      }
    }
    if (type == "TAN") {
      if (this.entity.TANDocument != null && this.entity.TANDocument != undefined) {
        this.fileUploader.upload(this.entity.TANDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.TAN_Ref_Id = result.documentId;
          }
        });

      }
    }
    if (type == "MOA") {
      if (this.entity.MOADocument != null && this.entity.MOADocument != undefined) {
        this.fileUploader.upload(this.entity.MOADocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.MOA_Ref_Id = result.documentId;
          }
        });

      }
    }
    if (type == "AOA") {
      if (this.entity.AOADocument != null && this.entity.AOADocument != undefined) {
        this.fileUploader.upload(this.entity.AOADocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.AOA_Ref_Id = result.documentId;
          }
        });

      }
    }
    if (type == "COI") {
      if (this.entity.COIDocument != null && this.entity.COIDocument != undefined) {
        this.fileUploader.upload(this.entity.COIDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.COIDocument = result.documentId;
          }
        });

      }
    }
    if (type == "RBI") {
      if (this.entity.RBIDocument != null && this.entity.RBIDocument != undefined) {
        this.fileUploader.upload(this.entity.RBIDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.RBIDocument = result.documentId;
          }
        });

      }

    }
    if (type == "OtherEnclosure") {
      if (this.entity.OtherEnclosureDocument != null && this.entity.OtherEnclosureDocument != undefined) {
        this.fileUploader.upload(this.entity.OtherEnclosureDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            this.entity.OtherEnclosureDocument = result.documentId;
          }
        });

      }

    }
    event.preventDefault();

  }




  save(event: any, type: any): void {
    // alert(JSON.stringify(this.proofTypes))
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);

    for (let row = 0; row < this.proofTypes.length; row++) {
      if (this.proofTypes[row].proofType == "address") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("Address is required")
          return
        }
      }
      if (this.proofTypes[row].proofType == "CIN") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("CIN is required")
          return
        }
      }
      if (this.proofTypes[row].proofType == "PAN") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("PAN is required")
          return
        }
      }
    }

    if (validations.length === 0) {
      // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;commented on 04-06-2024 by jessil for #I238
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
      if (this.entity.Phone.length != 10) {
        this.notification.showWarning("Invalid Phone No.");
        this.saveDisabled = false;
        return;
      }

      const pannum = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      for (let row = 0; row < this.proofTypes.length; row++) {
        if (this.proofTypes[row].proofType == "PAN") {
          this.panCheck = pannum.test(String(this.proofTypes[row].value).toString());
          if (this.panCheck == false) {
            this.notification.showWarning("Invalid PAN No.");
            this.saveDisabled = false;
            return;
          }
        }
      }
      if (this.emailcheck === false) {
        this.notification.showWarning("Email not valid");
        this.saveDisabled = false;
        return;
      }

      else {
        this._companyService.checkEmail(this.entity.EmailId, this.entity.Company_Id).subscribe((response) => {
          if (response.Success == false) {
            this.notification.showWarning("Email already exists");
            this.saveDisabled = false;
            return;
          }
          else {
            this._companyService.checkDuplication(this.entity.CompanyName, this.entity.Company_Id).subscribe((res) => {
              if (res.Success == false) {
                this.notification.showWarning('Company already exists');
                this.saveDisabled = false;
              }
              else {
                // for (let row = 0; row < this.proofTypes.length; row++) {
                //   // if (this.proofTypes[row].proofType == "address") {
                //   if (this.entity.addressDocument != null && this.entity.addressDocument != undefined) {
                //     this.fileUploader.upload(this.entity.addressDocument, '').subscribe((result: any) => {
                //       if (result.succeeded) {
                //         this.entity.Address_Ref_Id = result.documentId;
                //       }
                //     })
                //   }
                // return this.entity;


                this._companyService.saveCompany(this.initializeSaveEntity(this.entity)).subscribe(() => {
                  if (this.entity.Company_Id == "00000000-0000-0000-0000-000000000000") {
                    this.notification.showSuccess('Saved Successfully');
                  }
                  else {
                    this.notification.showSuccess('Updated Successfully');
                  }

                  this.listView = true;
                  this.clearCompany();
                  this.getAllCompanys();
                })
              }


            }

            )
            // }
          }
        })

      }
    }

    else {
      this.saveDisabled = false;
    }
  }


  initializeSaveEntity(entity: Company): Company {
    for (let index = 0; index < this.proofTypes.length; index++) {
      if (this.proofTypes[index].proofType === "address") {
        // entity.Address_Ref_Id = this.proofTypes[index].refId;
        entity.CompanyAddress = this.proofTypes[index].value;
      }
      if (this.proofTypes[index].proofType === "PAN") {
        entity.PAN = this.proofTypes[index].value;
      }
      if (this.proofTypes[index].proofType === "CIN") {
        entity.CIN = this.proofTypes[index].value;
      }
      if (this.proofTypes[index].proofType === "TAN") {
        entity.TAN = this.proofTypes[index].value;
      }
    }
    return entity;
  }




  // if (this.entity.Document != null && this.entity.Document != undefined) {
  //   this.fileUploader.upload(this.entity.Document, '').subscribe((result: any) => {


  // for (let row = 0; row < this.proofTypes.length; row++) {        needed
  // this.fileUploader.upload(this.proofTypes[row], '').subscribe((result: any) => {
  // if (this.proofTypes[row].proofType == "address") {
  //   this.entity.CompanyAddress = this.proofTypes[row].value;
  //   this.entity.Address_Ref_Id = result.documentId;
  // }                                                 needed

  // if (row == this.proofTypes.length-1) {

  // });
  // }
  // })
  // }
  // for (let row = 0; row < this.proofTypes.length; row++) {
  //   this.fileUploader.upload(this.proofTypes[row].Document, '').subscribe((result: any) => {
  //     if (this.proofTypes[row].proofType == "address") {
  //       this.entity.CompanyAddress = this.proofTypes[row].value;
  //       this.entity.Address_Ref_Id = result.documentId;
  //     }
  //     if (this.proofTypes[row].proofType == "CIN") { 
  //       this.entity.CIN = this.proofTypes[row].value
  //      }
  //     if (this.proofTypes[row].proofType == "PAN") { this.entity.PAN = this.proofTypes[row].value }
  //     if (this.proofTypes[row].proofType == "TAN") { this.entity.TAN = this.proofTypes[row].value }
  //     if (this.proofTypes[row].proofType == "MOA") { this.entity.MOA = this.proofTypes[row].value }
  //     if (this.proofTypes[row].proofType == "AOA") { this.entity.AOA = this.proofTypes[row].value }
  //     if (this.proofTypes[row].proofType == "COI") { this.entity.COI = this.proofTypes[row].value }
  //     if (this.proofTypes[row].proofType == "RBI") { this.entity.RBI_License = this.proofTypes[row].value }

  //     if (row == this.proofTypes.length-1) {
  //       this._companyService.saveCompany(this.initializeSaveEntity(this.entity)).subscribe(() => {
  //         if (this.entity.Company_Id == "00000000-0000-0000-0000-000000000000") {
  //           this.notification.showSuccess('Saved Successfully');
  //         }
  //         else {
  //           this.notification.showSuccess('Updated Successfully');
  //         }

  //         this.listView = true;
  //         this.clearCompany();
  //         this.getAllCompanys();
  //       })
  //     }
  //   });
  // }

  // }
  // }
  // }
  // )

  //     );
  //   }




  gotoBack(): void {
    this.listView = true;
    this.clearCompany();
  }
  refreshCompany(event: any): void {
    this.companys = [];
    this.getAllCompanys();
  }
  clearCompany(): void {
    this.entity = new Company();
    this.saveDisabled = false;
    this.download = ""; this.CINdownload = ""; this.PANdownload = ""; this.TANdownload = "";
    this.MOAdownload = ""; this.AOAdownload = ""; this.COIdownload = ""; this.RBIdownload = ""; this.Otherdownload = "";
    this.proofTypes = [
      { proofType: "address", displayName: "Address", value: "", IsMandatory: true },
      { proofType: "CIN", displayName: "CIN", value: "", maxlength: 21, IsMandatory: true },
      { proofType: "PAN", displayName: "PAN", value: "", maxlength: 10, IsMandatory: true },
      { proofType: "TAN", displayName: "GSTIN", value: "", maxlength: 15 },
      { proofType: "MOA", displayName: "MOA", value: "", Label: "Choose MOA to upload" },
      { proofType: "AOA", displayName: "AOA", value: "", Label: "Choose AOA to upload" },
      { proofType: "COI", displayName: "COI", value: "", Label: "Choose COI to upload" },
      { proofType: "RBI", displayName: "RBI", value: "", Label: "Choose RBI Licence to upload" },
      { proofType: "OtherEnclosure", displayName: "OtherEnclosure", value: "", Label: "Choose OtherEnclosure to upload" }
    ]
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  Uploaddocuments(event: any, type: string): void {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.CINurl = String(event.target?.result);
        this.CINisButtonVisible = true;
      }
      this.entity.Document = event.target.files[0];
    }
    if (this.entity.Document != null && this.entity.Document != undefined) {
      this.fileUploader.upload(this.entity.Document, '').subscribe((result: any) => {
        if (result.succeeded) {
          this.entity.CIN_Ref_Id = result.documentId;
        }
      });
    }
  }


  fileChanged(event: any, type: any): void {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {

        var reader = new FileReader();
        // type.document = event.target.files[0];
        type.Document = event.target.files[0];
        type.CiNdocument = event.target.files[0];

        if (type.proofType === "address") {
          this.entity.addressDocument = event.target.files[0]
          const link: any = document.getElementById("link")
          // let first=event.target.files[0]
          link.download = this.entity.addressDocument.name;
          link.href = URL.createObjectURL(this.entity.addressDocument)
          this.download = this.entity.addressDocument.name;

          this.fileUploader.upload(this.entity.addressDocument, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.Address_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.addressDocument);
        }
        else if (type.proofType === "CIN") {
          this.entity.CINDocDownload = event.target.files[0]
          const CINlink: any = document.getElementById("CINlink")
          // let first=event.target.files[0]
          CINlink.download = this.entity.CINDocDownload.name;
          CINlink.href = URL.createObjectURL(this.entity.CINDocDownload)
          this.CINdownload = this.entity.CINDocDownload.name;
          this.fileUploader.upload(this.entity.CINDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.CIN_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.CINDocDownload);
        }
        else if (type.proofType === "PAN") {
          this.entity.PANDocDownload = event.target.files[0]
          const PANlink: any = document.getElementById("PANlink")
          // let first=event.target.files[0]
          PANlink.download = this.entity.PANDocDownload.name;
          PANlink.href = URL.createObjectURL(this.entity.PANDocDownload)
          this.PANdownload = this.entity.PANDocDownload.name;
          this.fileUploader.upload(this.entity.PANDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.PAN_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.PANDocDownload);
        }
        else if (type.proofType === "TAN") {
          this.entity.TANDocDownload = event.target.files[0]
          const TANlink: any = document.getElementById("TANlink")
          // let first=event.target.files[0]
          TANlink.download = this.entity.TANDocDownload.name;
          TANlink.href = URL.createObjectURL(this.entity.TANDocDownload)
          this.TANdownload = this.entity.TANDocDownload.name;
          this.fileUploader.upload(this.entity.TANDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.TAN_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.TANDocDownload);
        }
        else if (type.proofType === "AOA") {
          this.entity.AOADocDownload = event.target.files[0]
          const AOAlink: any = document.getElementById("AOAlink")
          // let first=event.target.files[0]
          AOAlink.download = this.entity.AOADocDownload.name;
          AOAlink.href = URL.createObjectURL(this.entity.AOADocDownload)
          this.AOAdownload = this.entity.AOADocDownload.name;
          this.fileUploader.upload(this.entity.AOADocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.AOA_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.AOADocDownload);
        }
        else if (type.proofType === "MOA") {
          this.entity.MOADocDownload = event.target.files[0]
          const MOAlink: any = document.getElementById("MOAlink")
          // let first=event.target.files[0]
          MOAlink.download = this.entity.MOADocDownload.name;
          MOAlink.href = URL.createObjectURL(this.entity.MOADocDownload)
          this.MOAdownload = this.entity.MOADocDownload.name;
          this.fileUploader.upload(this.entity.MOADocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.MOA_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.MOADocDownload);
        }
        else if (type.proofType === "COI") {
          this.entity.COIDocDownload = event.target.files[0]
          const COIlink: any = document.getElementById("COIlink")
          // let first=event.target.files[0]
          COIlink.download = this.entity.COIDocDownload.name;
          COIlink.href = URL.createObjectURL(this.entity.COIDocDownload)
          this.COIdownload = this.entity.COIDocDownload.name;
          this.fileUploader.upload(this.entity.COIDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.COI_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.COIDocDownload);
        }
        else if (type.proofType === "RBI") {
          this.entity.RBIDocDownload = event.target.files[0]
          const RBIlink: any = document.getElementById("RBIlink")
          // let first=event.target.files[0]
          RBIlink.download = this.entity.RBIDocDownload.name;
          RBIlink.href = URL.createObjectURL(this.entity.RBIDocDownload)
          this.RBIdownload = this.entity.RBIDocDownload.name;
          this.fileUploader.upload(this.entity.RBIDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.RBI_License_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.RBIDocDownload);
        }
        else if (type.proofType === "OtherEnclosure") {
          this.entity.OtherDocDownload = event.target.files[0]
          const Otherlink: any = document.getElementById("Otherlink")
          // let first=event.target.files[0]
          Otherlink.download = this.entity.OtherDocDownload.name;
          Otherlink.href = URL.createObjectURL(this.entity.OtherDocDownload)
          this.Otherdownload = this.entity.OtherDocDownload.name;
          this.fileUploader.upload(this.entity.OtherDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.OtherEnclosure_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.OtherDocDownload);
        }

        reader.onload = (event) => {
          // type.addressurl = String(event.target?.result);
          // type.PANurl = String(event.target?.result);
          // type.CINurl = String(event.target?.result);
          type.result = event.target?.result;
          type.url = String(event.target?.result);
          type.button = true;
          // if (type == "address") {
          //   this.addressurl = String(event.target?.result);
          //   this.addressisButtonVisible = true;
          // }
          // else if (type == "CIN") {
          //   this.CINurl = String(event.target?.result);
          //   this.CINisButtonVisible = true;
          // }
          // else if (type == "PAN") {
          //   this.PANurl = String(event.target?.result);
          //   this.CINisButtonVisible = true;
          // }
          // else if (type == "TAN") {
          //   this.TANurl = String(event.target?.result);
          //   this.TANisButtonVisible = true;
          // }
          // else if (type == "MOA") {
          //   this.MOAurl = String(event.target?.result);
          //   this.MOAisButtonVisible = true;
          // }
          // else if (type == "AOA") {
          //   this.AOAurl = String(event.target?.result);
          //   this.AOAisButtonVisible = true;
          // }
          // else if (type == "COI") {
          //   this.COIurl = String(event.target?.result);
          //   this.COIisButtonVisible = true;
          // }
          // else if (type == "RBI") {
          //   this.RBIurl = String(event.target?.result);
          //   this.RBIisButtonVisible = true;
          // }

          event.preventDefault();
        }
        reader.readAsDataURL(event.target.files[0]);
        // if (type == "address") {
        //   this.entity.Document = event.target.files[0];
        // }
        // else if (type == "CIN") {
        //   this.entity.cinDocument = event.target.files[0];
        // }
        // if (type == "PAN") {
        //   this.entity.PANDocument = event.target.files[0];
        // }
        // else if (type == "TAN") {
        //   this.entity.TANDocument = event.target.files[0];
        // }
        // if (type == "MOA") {
        //   this.entity.MOADocument = event.target.files[0];
        // }
        // else if (type == "AOA") {
        //   this.entity.AOADocument = event.target.files[0];
        // }
        // if (type == "COI") {
        //   this.entity.COI = event.target.files[0];
        // }
        // else if (type == "RBI") {
        //   this.entity.RBIDocument = event.target.files[0];
        // }
        //this.entity.Document = event.target.files[1];
      }
      this.savedoc = true;
    }
  }

  removeImage(event: any, type: any): void {
    type.url = ''
    type.button = false;
    // this.addressurl = '';
    // this.addressisButtonVisible = false;
    // if (type == "address") {
    //   this.addressurl = '';
    //   this.addressisButtonVisible = false;
    // }
    // else if (type == "CIN") {
    //   this.CINurl = '';
    //   this.CINisButtonVisible = false;
    // }
    // else if (type == "PAN") {
    //   this.PANurl = '';
    //   this.CINisButtonVisible = false;
    // }
    // else if (type == "TAN") {
    //   this.TANurl = '';
    //   this.TANisButtonVisible = false;
    // }
    // else if (type == "MOA") {
    //   this.MOAurl = '';
    //   this.MOAisButtonVisible = false;
    // }
    // else if (type == "AOA") {
    //   this.AOAurl = '';
    //   this.AOAisButtonVisible = false;
    // }
    // else if (type == "COI") {
    //   this.COIurl = '';
    //   this.COIisButtonVisible = false;
    // }
    // else if (type == "RBI") {
    //   this.RBIurl = '';
    //   this.RBIisButtonVisible = false;
    // } Document

    // this.entity.Document = null;
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Company_Id = dataItem.Company_Id;
    this.details = [];
    this._companyService.viewCompany(this.entity.Company_Id).subscribe((data: Array<Company>) => {
      this.opened = true;
      this.details = data[0];
    })
  }
  downloadFunction(type: any): void {
    // let documentId = entity.Ref_Id;
    if (type.proofType === "address") {
    if(this.entity.Address_Ref_Id!=null && this.entity.AddressFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.AddressFileName,
        Ref_Id: this.entity.Address_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
    else if (type.proofType === "CIN") {
      if(this.entity.CIN_Ref_Id!=null && this.entity.CINFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.CINFileName,
        Ref_Id: this.entity.CIN_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
    else if (type.proofType === "PAN") {
      if(this.entity.PAN_Ref_Id!=null && this.entity.PANFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.PANFileName,
        Ref_Id: this.entity.PAN_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
    else if (type.proofType === "TAN") {
      if(this.entity.TAN_Ref_Id!=null && this.entity.TANFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.TANFileName,
        Ref_Id: this.entity.TAN_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
    else if (type.proofType === "MOA") {
      if(this.entity.MOA_Ref_Id!=null && this.entity.MOAFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.MOAFileName,
        Ref_Id: this.entity.MOA_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }

    else if (type.proofType === "AOA") {
      if(this.entity.AOA_Ref_Id!=null && this.entity.AOAFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.AOAFileName,
        Ref_Id: this.entity.AOA_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }

    else if (type.proofType === "COI") {
      if(this.entity.COI_Ref_Id!=null && this.entity.COIFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.COIFileName,
        Ref_Id: this.entity.COI_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
      else{
        this.notification.showWarning('No documents found');
      }
    }
    else if (type.proofType === "RBI") {
      if(this.entity.RBI_License_Ref_Id!=null && this.entity.RBIFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.RBIFileName,
        Ref_Id: this.entity.RBI_License_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
      else{
        this.notification.showWarning('No documents found');
      }
    }
    else if (type.proofType === "OtherEnclosure") {
      if(this.entity.OtherEnclosure_Ref_Id!=null && this.entity.OtherFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.OtherFileName,
        Ref_Id: this.entity.OtherEnclosure_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }


  }

}
